/* eslint-disable react/require-default-props */
import { Grid } from '@mui/material';
import { useContext } from 'react';

import {
  convertClientKind,
  convertEvaluationType,
  convertInspectionType,
  convertPropertyUse,
  convertReportFunction,
  convertReportGoal,
} from '../../../api/enumerations';
import { WorkOrderData } from '../../../api/workOrders/types';
import { IconPersonMS } from '../../../constants/icons';
import { GlobalContext } from '../../../context/global';
import { SectionBox } from '../../UI/Box';
import { InputTitle, SmallStyledInput } from '../../UI/Typography';
import { Constants } from './constants';
import { SectionTitle } from './styles';

interface ClientDataProps {
  propertyData?: WorkOrderData;
  showProgressBar?: boolean;
}

export function ClientData({
  propertyData,
  showProgressBar = true,
}: ClientDataProps): JSX.Element {
  const { isHiveOwner } = useContext(GlobalContext);
  return (
    <SectionBox sx={{ margin: showProgressBar ? '0 0 20px 34px' : '0 0 20px' }}>
      <SectionTitle>
        {IconPersonMS}
        {Constants.clientData}
      </SectionTitle>
      <Grid container spacing={4}>
        <Grid item xs={6} xl={4}>
          <InputTitle>
            {isHiveOwner ? Constants.bankClientName : Constants.clientName}
          </InputTitle>
          <SmallStyledInput>{propertyData?.client_name}</SmallStyledInput>
        </Grid>
        <Grid item xs={6} xl={4}>
          <InputTitle>{Constants.solicitor}</InputTitle>
          <SmallStyledInput>{propertyData?.requester_name}</SmallStyledInput>
        </Grid>
        <Grid item xs={6} xl={4}>
          <InputTitle>{Constants.goal}</InputTitle>
          <SmallStyledInput>
            {propertyData && convertReportGoal(propertyData.report_goal)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={6} xl={3}>
          <InputTitle>{Constants.evaluationType}</InputTitle>
          <SmallStyledInput>
            {propertyData &&
              convertEvaluationType(propertyData.evaluation_type)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={4} xl={3}>
          <InputTitle>{Constants.clientType}</InputTitle>
          <SmallStyledInput>
            {propertyData && convertClientKind(propertyData.client_kind)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={4} xl={3}>
          <InputTitle>{Constants.function}</InputTitle>
          <SmallStyledInput>
            {propertyData &&
              convertReportFunction(propertyData.report_function)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={4} xl={3}>
          <InputTitle>{Constants.propertyUse}</InputTitle>
          <SmallStyledInput>
            {propertyData && convertPropertyUse(propertyData.use)}
          </SmallStyledInput>
        </Grid>
        {propertyData?.hive_request !== null && (
          <Grid item xs={4} xl={3}>
            <InputTitle>{Constants.inspectionType}</InputTitle>
            <SmallStyledInput>
              {propertyData &&
                convertInspectionType(propertyData.inspection_type)}
            </SmallStyledInput>
          </Grid>
        )}
      </Grid>
    </SectionBox>
  );
}
